



































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import CompassItemContainer from '@/components/CompassItemContainer.vue';
import CompassItemRatio from '@/components/CompassItemRatio.vue';
import CompassDetails from '@/components/CompassDetails.vue';
import DynamicColumnChart from '@/charts/DynamicColumnChart.vue';
import DynamicCompassBar from '@/charts/DynamicCompassBar.vue';
import CompassCompetitorsNew from '@/components/CompassCompetitorsNew.vue';
import CompassNew from '@/components/CompassNew.vue';
import CompassIndustryNew from '@/components/CompassIndustryNew.vue';
import KeyValue from '@/utils/KeyValue';

@Component({
  components: {
    CompassIndustryNew,
    CompassNew,
    CompassCompetitorsNew,
    CompassItemContainer,
    CompassItemRatio,
    CompassDetails,
    DynamicColumnChart,
    DynamicCompassBar,
  },
})
export default class ExtendedCompass extends Vue {
  @Prop() readonly type: string | undefined;
  @Prop() readonly subType: string | undefined;
  @Prop() readonly ranking: any | undefined;
  @Prop() readonly rankingC1: any | undefined;
  @Prop() readonly rankingC2: any | undefined;
  @Prop() readonly profitloss: any | undefined;
  @Prop() readonly overview: any | undefined;
  @Prop() readonly overviewC1: any | undefined;
  @Prop() readonly overviewC2: any | undefined;

  hovered: any | null = null;
  subChart: string | undefined = '';

  mounted() {
    if (this.subType) {
      this.subChart = this.subType;
      this.hovered = KeyValue.ByKey(this.subType);
    }
  }

  onHoverChanged(e: any) {
    this.hovered = e;
  }

  onClicked() {
    this.subChart = this.hovered.key;
  }

  onBack() {
    this.hovered = null;
    this.subChart = '';
  }

  get ranking1() {
    if (this.ranking) {
      return this.ranking.sheets[0];
    } else {
      return undefined;
    }
  }

  get definition() {
    if (this.hovered) {
      return this.hovered.Definition();
    }
    return '';
  }

  get overviewCompetitionLatest() {
    if (!this.overview) {
      return undefined;
    }
    if (this.overviewC2) {
      return [
        this.overview,
        this.overviewC1,
        this.overviewC2,
      ];
    } else {
      return [
        this.overview,
        this.overviewC1,
      ];
    }
  }

  get rankingCompetitionAll() {
    if (!this.ranking) {
      return undefined;
    }
    const values = [];
    values.push(...(this.ranking.sheets.slice(0, 3).map((x: any) => {
      x.overview = this.overview;
      x.index = 0;
      return x;
    })));
    values.push(...(this.rankingC1.sheets.slice(0, 3).map((x: any) => {
      x.overview = this.overviewC1;
      x.index = 1;
      return x;
    })));
    if (this.rankingC2) {
      values.push(...(this.rankingC2.sheets.slice(0, 3).map((x: any) => {
        x.overview = this.overviewC2;
        x.index = 2;
        return x;
      })));
    }
    return {sheets: values};
  }

  get rankingCompetitionLatest() {
    if (!this.ranking) {
      return undefined;
    }
    if (this.rankingC2) {
      return {
        sheets: [
          this.ranking.sheets[0],
          this.rankingC1.sheets[0],
          this.rankingC2.sheets[0],
        ],
      };
    } else {
      return {
        sheets: [
          this.ranking.sheets[0],
          this.rankingC1.sheets[0],
        ],
      };
    }
  }

  get isPrint(): boolean {
    if (!this.$router || !this.$router.currentRoute || !this.$router.currentRoute.name) {
      return false;
    }
    return this.$router.currentRoute.name.endsWith('print');
  }
}

